module.exports = __webpack_public_path__ + "static/rzutjanowo2-5bb03ddeb4f60d1f0ed4860e0173e08c.jpg";